export default {
  "category.title": "分类浏览",
  "category.subtitle": "按类别查找草榴社区相关文章",
  "category.allArticles": "全部文章",
  "category.noArticles": "该分类下暂无文章",
  "category.articlesFound": "共找到 {{count}} 篇文章",
  "category.readMore": "阅读全文",
  "category.publishedAt": "发布于",
}